import { uiComponentCustomConfigService } from '@/api/services/common/ui-component/custom-config/ui-component-custom-config.service'
import { dashboardModuleService } from '@/modules/dashboard-module/services/dashboard-module.service'
import { DashboardModuleLayoutWidget, DashboardModuleLayoutWidgetWidgetLink, DashboardModuleSummaryType, DashboardModuleWidgetOption } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { DashboardModuleSharedWidgetsPendingWidgetState, DashboardModuleUIComponentsWidgets, initialDashboardModuleSharedWidgetsPendingWidgetState } from '@/modules/dashboard-module/shared/widgets/pending-widget/dashboard-module-shared-widgets-pending-widget.model'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { store } from '@/store/store'
import { Vue, Prop, Component } from 'vue-property-decorator'
import sectionServices from '@/api/resources/common/sectionServices'
import { CommonSectionResponse } from '@/api/services/common/section/common-section.dto'
import { StrictNullable } from '@/shared/types/app.types'
@Component({
    components: {
    }
})
export default class DashboardModuleSharedWidgetsPendingWidget extends Vue {
    @Prop(Object) readonly widgetData!: DashboardModuleLayoutWidget

    state: DashboardModuleSharedWidgetsPendingWidgetState
    constructor() {
        super()
        this.state = initialDashboardModuleSharedWidgetsPendingWidgetState()
    }

    async mounted(): Promise<void> {
        if (this.widgetData.widgetOption) {
            await this._getWidgetCount(
                this.widgetData.widgetOption,
                this.state.laboratoryId
            )
        } else {
            this.state.value = -1
        }
    }

    get valueExists(): boolean {
        return this.state.value !== null
    }

    get colorWidget(): string {
        const colorWidget = this.widgetData?.color ?? ''
        return this.valueExists ? colorWidget : ''
    }

    get link(): DashboardModuleLayoutWidgetWidgetLink | string {
        return this.widgetData.widgetLink ?? ''
    }

    get optionLink(): DashboardModuleWidgetOption | string {
        return this.widgetData.widgetOption ?? ''
    }

    get isValueWidget(): boolean {
        return this.state.value !== -1
    }

    get getDurationAnimation(): number {
        if (this.state.value) {
            return this.state?.value <= 10 ? 0.25 : 1
        }
        return 0
    }

    async removeWidget(): Promise<void> {
        await store.dispatch('dashboard/removeWidgetAndSetVisible', this.widgetData)
    }

    private async _getWidgetCount(widgetOption: DashboardModuleWidgetOption, laboratoryId: number): Promise<void> {
        switch (widgetOption) {
        case DashboardModuleWidgetOption.REQUESTS_WITH_AP_REPORT_NOT_SEEN:
            this._setDataWidget(dashboardModuleService.getSummaryOfUnseenRequests())
            break
        case DashboardModuleWidgetOption.LOCKED_REQUESTS:
            this._setDataWidget(dashboardModuleService.getSummaryOfLockedRequests())
            break
        case DashboardModuleWidgetOption.REGISTRY_TODAY:
            this._setDataWidget(dashboardModuleService.getSummaryOfRegisteredTodayCases(laboratoryId))
            break
        case DashboardModuleWidgetOption.REGISTRY_REQUESTED:
            this._setDataWidget(dashboardModuleService.getSummaryOfRequestedRequests(laboratoryId))
            break
        case DashboardModuleWidgetOption.REGISTRY_REQUESTS_LOCKED:
            this._setDataWidget(dashboardModuleService.getSummaryOfRegistryLockedRequests(laboratoryId))
            break
        case DashboardModuleWidgetOption.PORTION_CUT:
            const sectionsPortionCut = await this._getLaboratorySummarySections(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfPortionsPendingCut(laboratoryId, sectionsPortionCut))
            break
        case DashboardModuleWidgetOption.PORTION_MAKE:
            const sectionsPortionMake = await this._getLaboratorySummarySections(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfPortionsPendingMake(laboratoryId, sectionsPortionMake))
            break
        case DashboardModuleWidgetOption.SUBPORTION_SCAN:
            const sectionsPortionToScanner = await this._getLaboratorySummarySections(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfSubPortionsPendingScan(laboratoryId, sectionsPortionToScanner))
            break
        case DashboardModuleWidgetOption.SUBPORTION_TO_SCANNER:
            const sectionsSubportionToScanner = await this._getLaboratorySummarySections(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfSubPortionsPendingToScanner(laboratoryId, sectionsSubportionToScanner))
            break
        case DashboardModuleWidgetOption.WASTE_TODAY:
            this._setDataWidget(dashboardModuleService.getSummaryOfSamplesDisposedToday(laboratoryId))
            break
        case DashboardModuleWidgetOption.PENDING_DISPOSAL:
            this._setDataWidget(dashboardModuleService.getSummaryOfSamplesPendingDisposal(laboratoryId))
            break
        case DashboardModuleWidgetOption.OPENED_INCIDENTS:
            this._setDataWidget(dashboardModuleService.getSummaryOfOpenIncidentsByLoggedInUser(laboratoryId))
            break
        case DashboardModuleWidgetOption.FOR_GROSSING:
            const typeSummaryForGrossing = await this._getGrossingSummaryType(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfSamplesPendingProcessing(laboratoryId, typeSummaryForGrossing))
            break
        case DashboardModuleWidgetOption.FOR_REGROSSING:
            const typeSummaryForRegrossing = await this._getGrossingSummaryType(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfSamplesPendingReProcessing(laboratoryId, typeSummaryForRegrossing))
            break
        case DashboardModuleWidgetOption.GROSSING_TODAY:
            const typeSummaryForGrossingToday = await this._getGrossingSummaryType(laboratoryId)
            this._setDataWidget(dashboardModuleService.getSummaryOfProcessedTodaySamples(laboratoryId, typeSummaryForGrossingToday))
            break
        }
    }

    private async _getLaboratorySummarySections(laboratoryId: number): Promise<number[]> {
        const sections: CommonSectionResponse[] = await PromiseUtils.toCallSecure(sectionServices.getSections(this.$store.getters.labId))
        const customConfig = await PromiseUtils.toCallSecure(uiComponentCustomConfigService.get<{ id: number, checked: boolean }[]>(DashboardModuleUIComponentsWidgets.LABORATORY, laboratoryId), () => true)
        if (customConfig && sections) {
            const checkedSections = Object.values(customConfig.config).filter(item => item.checked).map(item => item.id)
            return sections.filter(item => checkedSections.includes(item.id)).map(item => item.id)
        }
        return []
    }

    private async _getGrossingSummaryType(laboratoryId: number): Promise<DashboardModuleSummaryType> {
        const customConfig = await PromiseUtils.toCallSecure(uiComponentCustomConfigService.get<{ defaultOptionId: StrictNullable<number>, sideBarName: string, viewAllEnabled: boolean }>(DashboardModuleUIComponentsWidgets.GROSSING, laboratoryId), () => true)
        if (customConfig && !customConfig.config?.viewAllEnabled) {
            return DashboardModuleSummaryType.MINE
        }
        return DashboardModuleSummaryType.VIEW_ALL
    }

    private async _setDataWidget(promise: Promise<number>): Promise<void> {
        const response = await PromiseUtils.toCallSecure(promise)
        this.state.value = response ?? -1
    }

    infoWidgetLink(link: string, option: string): void {
        this.$router.push({ name: link, params: { sidebarOption: option } })
    }
}
